import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  role: number;
  user: number;
}

/** POST `/user/user_role/` — assigns one user to one Role (`{user, role}`). */
export const useCreateUserRole = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(`${env.verifyServiceUrl}user/user_role/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
